import * as React from "react";
import {connect} from 'react-redux';
import * as selectors from "../selectors";
import {
    SetShowOnlyObjektlistAttributes,
    setShowOnlyObjektlistAttributes,
    SetShowOnlySelectedFeatures,
    setShowOnlySelectedFeatures,
    setShowQualityParams,
    SetShowQualityParams,
    SetShowSubmittedFeatures,
    setShowSubmittedFeatures,
    setUseDescriptiveName,
    SetUseDescriptiveName,
} from "../reducers/actions";
import FeaturesState from "../domain/FeaturesState";
import classNames = require("classnames");

interface MenuState {
}

interface TagProps {
    doCloseMenu: () => void;
}
interface StateProps {
    showSubmittedFeatures: boolean;
    showOnlyObjectlistAttributes: boolean;
    showOnlySelectedFeatures: boolean;
    showQualityParams: boolean;
    useDescriptiveName: boolean;
}

interface DispatchProps {
    doSetShowSubmittedFeatures: SetShowSubmittedFeatures;
    doSetShowOnlyObjektlistAttributes: SetShowOnlyObjektlistAttributes;
    doSetShowOnlySelectedFeatures: SetShowOnlySelectedFeatures;
    doSetShowQualityParams: SetShowQualityParams;
    doSetUseDescriptiveName: SetUseDescriptiveName;
}



const mapStateToProps = (state: FeaturesState): StateProps => {
    return {
        showSubmittedFeatures: selectors.showSubmittedFeatures(state),
        showOnlyObjectlistAttributes: selectors.showOnlyObjektlistAttributes(state),
        showOnlySelectedFeatures: selectors.showOnlySelectedFeatures(state),
        showQualityParams: selectors.stateShowQualityParams(state),
        useDescriptiveName: selectors.stateUseDescriptiveName(state),
    }
};

const mapDispatchToProps: DispatchProps = ({
    doSetShowSubmittedFeatures: setShowSubmittedFeatures,
    doSetShowOnlyObjektlistAttributes: setShowOnlyObjektlistAttributes,
    doSetShowOnlySelectedFeatures: setShowOnlySelectedFeatures,
    doSetShowQualityParams: setShowQualityParams,
    doSetUseDescriptiveName: setUseDescriptiveName,
});

type Props = TagProps & StateProps & DispatchProps;

class ViewSettingsMenu extends React.Component<Props, MenuState> {

    render() {

        let showOnlyObjektlistAttributesClasses = classNames(
            "menuElement",
            {
                "disabled": false,
                "checked" : this.props.showOnlyObjectlistAttributes,
            });

        let showQualityParamsClasses = classNames(
            "menuElement",
            {
                "disabled": false,
                "checked" : this.props.showQualityParams,
            });

        let hideSubmittedFeaturesClasses = classNames(
            "menuElement",
            {
                "disabled": false,
                "checked": !this.props.showSubmittedFeatures,
            });

        let showOnlySelectedFeaturesClasses = classNames(
            "menuElement",
            {
                "disabled": false,
                "checked": this.props.showOnlySelectedFeatures,
            });

        let useDescriptiveNameClasses = classNames(
            "menuElement",
            {
                "disabled": false,
                "checked": this.props.useDescriptiveName,
            });

        return (
            <div className="viewsettings-menu df-grid-menu">
                <div className={showOnlyObjektlistAttributesClasses} onClick={() => this.clickShowOnlyObjektlistAttributes()}><span className="checked-icon fas fa-check" />Vis kun egenskaper fra objektlista</div>
                <div className={showQualityParamsClasses} onClick={() => this.clickShowQualityParams()}><span className="checked-icon fas fa-check" />Vis Kvalitetsparametre</div>
                <div className={hideSubmittedFeaturesClasses} onClick={() => this.clickHideSubmittedFeatures()}><span className="checked-icon fas fa-check" />Skjul vegobjekter som er under eksport til NVDB</div>
                <div className={showOnlySelectedFeaturesClasses} onClick={() => this.clickShowOnlySelectedFeatures()}><span className="checked-icon fas fa-check" />Vis kun valgte vegobjekter</div>
                <div className={useDescriptiveNameClasses} onClick={() => this.clickUseDescriptiveName()}><span className="checked-icon fas fa-check" />Vis beskrivelse i stedet for navn</div>
            </div>
        );
    }

    clickShowOnlyObjektlistAttributes() {
        let {doCloseMenu, doSetShowOnlyObjektlistAttributes, showOnlyObjectlistAttributes} = this.props;
        doSetShowOnlyObjektlistAttributes(!showOnlyObjectlistAttributes);
        doCloseMenu();
    }

    clickShowQualityParams() {
        let {doCloseMenu, showQualityParams, doSetShowQualityParams} = this.props;
        doSetShowQualityParams(!showQualityParams);
        doCloseMenu();
    }

    clickHideSubmittedFeatures() {
        let {showSubmittedFeatures, doCloseMenu, doSetShowSubmittedFeatures} = this.props;
        doSetShowSubmittedFeatures(!showSubmittedFeatures);
        doCloseMenu();
    }

    clickShowOnlySelectedFeatures() {
        let {showOnlySelectedFeatures,doCloseMenu,doSetShowOnlySelectedFeatures} = this.props;
        doSetShowOnlySelectedFeatures(!showOnlySelectedFeatures);
        doCloseMenu();
    }

    clickUseDescriptiveName() {
        let {useDescriptiveName,doCloseMenu,doSetUseDescriptiveName} = this.props;
        doSetUseDescriptiveName(!useDescriptiveName);
        doCloseMenu();
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewSettingsMenu);



